import React from "react";
import Importacao from "../Importacao";

// PO1-3325 — Sustentação > Lupa de Inconsistências: página própria (pedido do
// Rodrigo no QA de 05/10) que reaproveita a tela de Integração de Documentos no
// modo "lupa": mesma fila, a grade "Documentos na fila" com todas as ações
// (Integrar, Autopilot, Ver arquivo, lotes) logo abaixo das bolhas, filtrada
// pela bolha em foco.
const LupaInconsistenciasPage = () => <Importacao modo="lupa" />;

export default LupaInconsistenciasPage;
